import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TipoApoioLogistico, TipoRoteiro } from '../shared/Util';
import { DatePipe, NgFor } from '@angular/common';

@Component({
  selector: 'app-card-crossdocking',
  imports: [NgFor, DatePipe],
  templateUrl: './card-crossdocking.component.html',
  styleUrl: './card-crossdocking.component.css'
})
export class CardCrossdockingComponent implements OnChanges{

  @Input() roteiros = [];
  @Input() pontoApoioSelecionado = TipoApoioLogistico.Todos; 
  roteirosCrossdocking = [];

  ngOnChanges() : void {
    this.roteirosCrossdocking = this.roteiros.filter((roteiro: any) => roteiro.TipoRoteiroID == TipoRoteiro.Crossdocking);
    if(this.pontoApoioSelecionado != TipoApoioLogistico.Todos)
    {
      this.roteirosCrossdocking = this.roteirosCrossdocking.filter((roteiro: any) => roteiro.clienteCrossdocking == this.pontoApoioSelecionado);
    }
  }
}
